module.exports = __webpack_public_path__ + "img/no.5fc94e90.svg";